export const deviceKeysForZ3KCustomTabs = [
    'id',
    'z3k_config',
    'device_type',
    'online',
    'hardware_type',
];
